export const PROFILE_ORDER = ["organizer", "referee", "player"];

export const PROFILE_META = {
  organizer: {
    home: "/app/organizer",
  },
  referee: {
    home: "/app/referees",
  },
  player: {
    home: "/app/following",
  },
};

// Resolve copy at render time so switching languages updates every profile UI.
export function getProfileMeta(profile, t) {
  const code = PROFILE_ORDER.includes(profile) ? profile : "organizer";
  return {
    home: PROFILE_META[code].home,
    label: t(`panels.${code}Label`),
    shortLabel: t(`panels.${code === "player" ? "playerShort" : `${code}Label`}`),
    description: t(`panels.${code}Description`),
  };
}

export function enabledProfilesFor(user) {
  const configured = Array.isArray(user?.account_profiles)
    ? user.account_profiles.filter((profile) => PROFILE_ORDER.includes(profile))
    : [];
  if (configured.length) return PROFILE_ORDER.filter((profile) => configured.includes(profile));
  if (PROFILE_ORDER.includes(user?.role)) return [user.role];
  return ["organizer"];
}

export function activeProfileFor(user) {
  const enabled = enabledProfilesFor(user);
  return enabled.includes(user?.active_profile) ? user.active_profile : enabled[0];
}

export function profileHome(profile) {
  return PROFILE_META[profile]?.home || PROFILE_META.organizer.home;
}

export function userProfileHome(user) {
  return profileHome(activeProfileFor(user));
}
